/* unplugin-vue-components disabled */import { render } from "./IdpChoose.vue?vue&type=template&id=5756c45e&scoped=true&ts=true"
import script from "./IdpChoose.vue?vue&type=script&lang=ts"
export * from "./IdpChoose.vue?vue&type=script&lang=ts"

import "./IdpChoose.vue?vue&type=style&index=0&id=5756c45e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5756c45e"]])

export default __exports__